var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovieBackdropPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:url(#b);}.d{fill:#f2f2f3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 445.25,
    y1: 335.75,
    x2: 54.75,
    y2: -54.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e83c96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e8488c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#eb6971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ee9e47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e112"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 500,
    height: 281
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M310.72,154.82c-17.78,0-32.23,14.43-32.23,32.23s14.45,32.23,32.23,32.23,32.23-14.43,32.23-32.23-14.45-32.23-32.23-32.23Zm17.91,35.81h-35.81v-7.16h35.81v7.16Zm-60.87,14.32h-53.73v-57.3h71.62v.23c13.41-8.62,29.46-9.45,42.97-3.8V61.71H171.05V219.29h106.15c-3.96-4.13-7.21-8.96-9.44-14.32Zm32.22-128.92h14.32v14.32h-14.32v-14.32Zm0,28.65h14.32v14.32h-14.32v-14.32Zm-85.95-28.65h71.62v57.3h-71.62v-57.3Zm-14.32,128.92h-14.32v-14.32h14.32v14.32Zm0-28.65h-14.32v-14.32h14.32v14.32Zm0-28.65h-14.32v-14.32h14.32v14.32Zm0-28.65h-14.32v-14.32h14.32v14.32Zm0-28.65h-14.32v-14.32h14.32v14.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieBackdropPlaceholder);
export default __webpack_public_path__ + "static/media/movie-backdrop-placeholder.17341af36bbac994d6878ce24ef591d7.svg";
export { ForwardRef as ReactComponent };